module.exports = __webpack_public_path__ + "media/vintage_rustic.7d4f5408.jpg";